import { LadiesMain } from "@modules/global/ladies-main"
import { fetchApi } from "@modules/news/api"
import { resetPagination } from "@modules/news/pagination/pagination"
import { Cookie } from "@modules/util/Cookie"
import { isMobile } from "@modules/util/device"
import { afterApiFetched } from "./after-api-fetched.ts"

// TODO needed on pages other than AZM?
/**
 * Notify user if snapshot was updated.
 * Use cases:
 *  - SessionID changes (new Session)
 *  - Current data index not found and new index used
 *  - new day
 */
export async function resetAdvertsForUserAndNotify() {
    resetPagination()
    await afterApiFetched(await fetchApi())
    LadiesMain.displayUserdataReloadedMessageInInfoPanel()

    if (isMobile()) {
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual"
        }
        document.documentElement.scrollTop = 0
    }
}

export function isUserSessionUpdated() {
    const savedUserSession = localStorage.getItem("savedUserSession") || ""
    const sessionIDCookie = new Cookie("PHPSESSID", { path: "/", domain: SiteInfo.cookieDomain })

    localStorage.setItem("savedUserSession", sessionIDCookie.value)

    return savedUserSession !== "" && savedUserSession !== sessionIDCookie.value
}
